import { IValue } from "./ivalue";
import { ControlType } from "../controltype";
import { EventEmitter } from "@angular/core";

export class DateValue implements IValue{
 
    clear$ = new EventEmitter();
    value: string;
    
    constructor(date: string = ''){
        this.value = date;
    }

    setOriginalValue(value: any): void {
        this.value = value.formatted;
    }
    getOriginalValue() {
        return this.value;
    }
    getControlType(): ControlType {
        return ControlType.Date;
    }
 
    isEmpty(): boolean {
        return !this.value;
    }
    clearValue(): void {
        this.value = undefined;
        this.clear$.emit();
    }
}